module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_5.17f0876b.png";